<template>
  <div>
    <common-hero :title="page.title" :subTitle="page.subTitle" />
    <!--team-area-start-->
    <div class="team-area">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 pt-3" v-for="(item, i) in content" :key="'bio' + i">
            <div class="single-team single-team-page">
              <div class="team-img team-page">
                <img
                  :src="item.photo[0] ? 'https://embe.iteas.dev' + item.photo[0].url : ''"
                  :alt="'Photo of ' + item.name"
                  width="100"
                  v-if="item.photo.length > 0"
                  class="text-wrap"
                />
              </div>
              <div class="team-containt">
                <h3>{{ item.name }}</h3>
                <p v-html="item.bio"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHero from '@/components/CommonHero';
import { getPageById } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  components: {
    CommonHero
  },
  props: {
    textElements: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    if (this.$route.meta.pageId)
      getPageById(this.$route.meta.pageId).then(res => {
        this.content = res.content.map(elt => translate(elt));
        this.page = res;
      });
    // then check content elements in page
  },
  data() {
    return {
      content: [],
      page: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
  background: black;
}
</style>
<style>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
}

.blog-text table th {
  width: 200px;
  text-align: center;
}

img.text-wrap {
  border-radius: 5%;
  float: left;
  margin-right: 15px;
}

.team-page {
  margin-bottom: 0px;
}

.single-team-page {
  padding: 30px;
}
</style>
